import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, switchMap, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { AuthStoreService } from './auth-store.service';
import { BYPASS_AUTH_REFRESH } from './http-context-tokens.js';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.context.get(BYPASS_AUTH_REFRESH)) {
    return next(req);
  }

  const authStore = inject(AuthStoreService);
  const router = inject(Router);

  return authStore.getValidAccessToken().pipe(
    switchMap((token) => {
      const authRequest = token
        ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
        : req;

      return next(authRequest).pipe(
        catchError((error) => {
          if (error instanceof HttpErrorResponse && error.status === 401) {
            authStore.clearAuthState();
            router.navigate(['/login']).catch(() => undefined);
          }
          return throwError(() => error);
        })
      );
    })
  );
};
